// Manufacturing capabilities — White Bull Global
// Capacity figures removed; exact specs confirmed at quote stage.

import packagingImg from "../assets/services/packaging.jpg";

export const SERVICES = [
  {
    slug: "capsules",
    title: "Capsules",
    short: "Hard-shell capsule filling and bottling for healthcare, wellness and sport-nutrition formulations.",
    headline: "Capsule manufacturing, certified and consistent.",
    intro:
      "We run automated capsule filling lines paired with high-speed bottling — built for steady, certified output across nutraceutical and healthcare SKUs.",
    image:
      "https://images.pexels.com/photos/11589213/pexels-photo-11589213.jpeg?auto=compress&cs=tinysrgb&w=1400",
    capacity: [],
    bullets: [
      "Hard-shell veg capsules, sizes per product spec",
      "In-line bottling with induction sealing & labelling",
      "FSSAI · GMP · AYUSH certified production",
    ],
  },
  {
    slug: "tablets",
    title: "Tablets",
    short: "Compressed and effervescent tablets, coated and uncoated, with output scalable to your order volume.",
    headline: "Tablet production — coated, uncoated, effervescent.",
    intro:
      "Our tableting line handles routine production runs and large bulk orders — including effervescent tablets — with output configurable based on tooling, blend and shift cycle.",
    image:
      "https://images.pexels.com/photos/7460059/pexels-photo-7460059.jpeg?auto=compress&cs=tinysrgb&w=1400",
    capacity: [],
    bullets: [
      "Compressed tablets — coated and uncoated formats",
      "Effervescent tablets — functional and quick-dissolve formats",
      "Custom shapes, sizes and embossing",
      "Batch-controlled with documented quality checks",
    ],
  },
  {
    slug: "powders",
    title: "Powders",
    short: "Blending and packing for protein blends, sport nutrition, herbal and nutraceutical powders.",
    headline: "Powder blending — built for batch volume.",
    intro:
      "Granulation, blending and finished-pack handover for protein, herbal and specialty nutraceutical powders. Designed for repeatable batches and consistent particle quality.",
    image:
      "https://images.pexels.com/photos/13779108/pexels-photo-13779108.jpeg?auto=compress&cs=tinysrgb&w=1400",
    capacity: [],
    bullets: [
      "Whey, plant-protein and nutraceutical powders",
      "Custom flavouring and ingredient blends",
      "Tightly controlled humidity and hygiene zones",
    ],
  },
  {
    slug: "packaging",
    title: "Packaging",
    short: "Pouches, sachets and finished-pack handling — aligned to your product, artwork and order volume.",
    headline: "Packaging that's built around your order.",
    intro:
      "From pouches and sachets to finished, market-ready packs, our packaging output is scheduled per order — sized to the product format, artwork, and the volume you commit during the quote.",
    image: packagingImg,
    capacity: [],
    bullets: [
      "Primary packaging (pouches, sachets, bottles)",
      "Secondary packaging & labelling",
      "Finished-pack consolidation for dispatch",
    ],
    note:
      "Packaging is finalised with the order — sizes, materials and pouching cycles are confirmed once the product brief and volume are locked.",
  },
];

export const SERVICE_QUOTE_NOTE =
  "Specifications, MOQ, lead time and finished-pack details are all finalised when you request a quote. Get in touch with your product brief and we'll respond within one business day.";

export const getServiceBySlug = (slug) =>
  SERVICES.find((s) => s.slug === slug);
